import { useQuery } from 'data-fetching-client';
import { GET_ELIGIBLE_ADDONS } from 'pricing-pages-api/add-ons/queries';

/**
 * Hook to fetch eligible addons (in-app only currently)
 */
export const useEligibleAddons = () => {
  const {
    data,
    error,
    loading
  } = useQuery(GET_ELIGIBLE_ADDONS);
  return {
    addOns: (data === null || data === void 0 ? void 0 : data.eligibleAddOns) || [],
    error,
    loading
  };
};